// extracted by mini-css-extract-plugin
export var container = "_ba-0";
export var icon = "_ba-1";
export var text = "_ba-2";